import {
  background,
  padding,
  spacing,
  flex,
  margin,
  gap,
  border,
  screen,
  radius,
} from '@ebh/capsule/theme';

export default {
  root: [
    flex('column'),
    {
      height: '100%',
      overflow: 'hidden',
    },
  ],

  form: [
    flex('column'),
    {
      flex: 1,
      overflow: 'hidden',
    },
  ],

  container: [
    background('white'),
    padding(4),
    flex('column', 'items-start'),
    screen('md', background('gray-100')),
    {
      flex: 1,
      overflowY: 'auto' as const,
      gap: spacing(3),
    },
  ],

  header: [
    flex('items-center'),
    padding(3),
    margin(3, 'top'),
    gap(5),
    border(1, 'bottom', 'accent-100'),
    screen('md', border(1, 'bottom', 'gray-500')),
    {
      height: spacing(15),
      flexShrink: 0,
    },
  ],

  inputGroup: [
    flex('column'),
    gap(5),
    margin(5, 'bottom'),
    {
      width: '100%',
    },
  ],

  passwordRules: [flex('column'), gap(3), margin(2, 'top')],
  ruleItem: [flex('row', 'items-center'), gap(2)],
  ruleIcon: [{ width: 16, height: 16 }],

  buttonContainer: [
    flex('center'),
    background('white'),
    border(1, 'top', 'accent-100'),
    {
      flexShrink: 0,
      width: '100%',
      cursor: 'pointer',
      height: spacing(20),
    },
  ],

  submitButton: [
    flex('center'),
    margin(2, 'top'),
    padding(4),
    { width: '90%' },
  ],

  eyeIcon: [
    flex('items-center'),
    padding(2, 'right'),
    {
      cursor: 'pointer',
    },
  ],

  miniContainer: [
    background('white'),
    padding(0),
    screen('md', padding(5)),
    radius(3),
    {
      width: '100%',
    },
  ],

  passwordResetHeader: [flex('row'), gap(2), margin(2, 'bottom')],
  passwordResetSuccessContainer: [flex('row'), gap(1)],
  tickIcon: [radius('50%'), { width: spacing(5), height: spacing(5) }],
  responseTickColor: [background('primary-400')],
  responseCrossColor: [background('error-400')],
};
